/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-danger */
import { useState, useEffect } from 'react';

import currencyFormatter from 'currency-formatter';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';

import { productClick } from '../../helpers/analytics';
import { buttonClickEvent } from '../../helpers/segment';
import useI18n from '../../hooks/use-i18n';
import { countryMap } from '../../language.config';
import { pageCodeMap, productLinks } from '../../links.config';
import { products } from '../../recoil/atoms/products';
import { cartPrice } from '../../recoil/selectors/cart';

import '../../styles/slider.scss';

export default function ShopItem({ data, type, dataLoaded }) {
  const i18n = useI18n();
  const codes = i18n.activeLocale.split('-');
  const country = codes.length === 2 ? codes[0] : 'sg';
  const productData = i18n.t('product_data');
  const shopAllPage = i18n.t('shopall_page');

  const [isOutOfStock, setIsOutOfStock] = useState(false);
  const productsData = useRecoilValue(products);
  const cartPriceDetails = useRecoilValue(cartPrice);

  const colorValues = productsData[data.productKey]?.colorValues
   && Object.values(productsData[data.productKey]?.colorValues);

  useEffect(() => {
    if (productsData[data.productKey]?.colorValues) {
      let isStock = false;
      Object.values(productsData[data.productKey]?.colorValues).forEach((variant) => {
        isStock = isStock || !variant.configuration.isOutOfStock;
      });
      setIsOutOfStock(!isStock);
    }
    setTimeout(() => {
      adjustAlignment();
    }, 200);
  }, [productsData, dataLoaded]);

  useEffect(() => {
    window.addEventListener('resize', adjustAlignment);
    return () => {
      window.removeEventListener('resize', adjustAlignment);
    };
  }, []);

  const adjustAlignment = () => {
    let div1MaxHeight = 0;
    let tagDivMaxHeight = 0;
    let colorDivMaxHeight = 0;
    const itemDivs = document.getElementsByClassName('shop-item-wrapper');
    const thisDiv = document.getElementById(`item-${data.productKey}`);
    const sameRowDivs = [];
    itemDivs.forEach((div) => {
      if (div.getBoundingClientRect().y === thisDiv.getBoundingClientRect().y) {
        sameRowDivs.push(div);
      }
    });

    sameRowDivs.forEach((div) => {
      if (tagDivMaxHeight < div.children[0].offsetHeight) tagDivMaxHeight = div.children[0].offsetHeight;
      if (colorDivMaxHeight < div.children[2].children[0].offsetHeight) {
        colorDivMaxHeight = div.children[2].children[0].offsetHeight;
      }
      if (div1MaxHeight < div.children[2].children[1].offsetHeight) {
        div1MaxHeight = div.children[2].children[1].offsetHeight;
      }
    });
    thisDiv.children[2].children[0].style.minHeight = `${colorDivMaxHeight}px`;
    thisDiv.children[2].children[1].style.minHeight = `${div1MaxHeight}px`;
    thisDiv.children[0].style.minHeight = `${tagDivMaxHeight}px`;
  };

  const productOnClick = () => {
    buttonClickEvent(`shop_all_${data.productKey}`,
      `Shop all ${productData[data.productKey]?.name}`,
      'webpage', 'Products All', productData[data.productKey]?.name, countryMap[country]);

    productClick(cartPriceDetails.currency_code, data);
  };

  if (data.productKey === 'WATERFLOSSER_TIP' && ['sg', 'my'].includes(country)) return null;

  return (
    <div className="shop-item-wrapper" id={`item-${data.productKey}`}>
      <div className="tag-wrapper">
        {data.configuration.discountLabel
        && (<span className="tag-item tag-type-1">{data.configuration.discountLabel}</span>)}
        {productData[data.productKey]?.tag && (
        <span className="tag-item tag-type-2">{productData[data.productKey]?.tag}</span>
        )}
      </div>
      <div className="img-wrapper">
        <img
          data-src={`/img/shopall/product_images/${data.productKey}.png`}
          className="img-1"
          alt={productData[data.productKey]?.name}
        />
      </div>
      <div className="extra-wrapper">
        <div className="color-display">
          {colorValues && colorValues.length > 1 && (
          <ul>
            {colorValues.map((item) => (
              <li key={item.id} className={`${item.color} ${item.configuration.isOutOfStock ? 'disabled' : ''}`} />
            ))}
          </ul>
          )}
          <div className="clearfix" />
        </div>
        <div>
          {isOutOfStock && (
          <span className="sold-out">{shopAllPage.sold_out}</span>)}
        </div>

      </div>
      <div className="slider-content">
        <div className="text-div">
          <h3>
            {productData[data.productKey]?.name}
          </h3>
        </div>

        {/* <span className="shop-item-pricing">
          {type === 'aligner' && (`${shopAllPage.from} `)}
          {data.configuration.strikeoutPrice !== 0 && (
          <>
            <s>
              {currencyFormatter.format(data.configuration.strikeoutPrice,
                { code: cartPriceDetails.currency_code })}
            </s>
              &nbsp;
          </>
          )}
          {currencyFormatter.format(data.price, { code: cartPriceDetails.currency_code })}
        </span> */}
      </div>
      <span className="shop-item-pricing">
        {type === 'aligner' && (`${shopAllPage.from} `)}
        {data.configuration.strikeoutPrice !== 0 && (
          <>
            <s>
              {currencyFormatter.format(data.configuration.strikeoutPrice,
                { code: cartPriceDetails.currency_code,
                  ...(cartPriceDetails.currency_code === 'SGD' && { symbol: 'S$' }) })}
            </s>
              {' '}
          </>
        )}
        {currencyFormatter.format(data.price, { code: cartPriceDetails.currency_code,
          ...(cartPriceDetails.currency_code === 'SGD' && { symbol: 'S$' }) })}
      </span>
      <Link
        href={`/[lng]/${data.catalogue.page ? pageCodeMap[data.catalogue?.page?.code]
          : productLinks[data.productKey]}`}
        as={`/${i18n.activeLocale}/${data.catalogue.page ? pageCodeMap[data.catalogue?.page?.code]
          : productLinks[data.productKey]}`}
      >
        <a
          className="linker"
          onClick={() => productOnClick()}
          role="presentation"
        >
            &nbsp;
        </a>
      </Link>
    </div>
  );
}

ShopItem.propTypes = {
  data: PropTypes.shape(),
  dataLoaded: PropTypes.shape(),
  type: PropTypes.string
};

ShopItem.defaultProps = {
  data: {},
  dataLoaded: {},
  type: 'product'
};
